import { MultiCombobox } from "@/components/ui/MultiCombobox";
import { useGetAllRegionsQuery } from "@/generated/graphql";

function RegionFilterDropdown({
  setValues,
  values,
}: {
  readonly setValues: (values: string[]) => void;
  readonly values: string[];
}) {
  const { data: allRegions } = useGetAllRegionsQuery();

  if (
    allRegions?.organization_region === undefined ||
    allRegions.organization_region.length === 0
  )
    return;

  return (
    <MultiCombobox
      defaultValue={values}
      onValueChange={setValues}
      options={allRegions.organization_region.map(({ name }) => ({
        label: name,
        value: name,
      }))}
      placeholder="Regionen auswählen"
    />
  );
}

export { RegionFilterDropdown };
